var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c("span", { staticClass: "body-2" }, [
            _vm._v("Relação de configurações para integração"),
          ]),
          _c("v-spacer"),
          _vm.hasIntegration(1) && _vm.acesso && _vm.acesso.instituicao
            ? _c("sys-institution-pop-over-setting", {
                attrs: { institution: _vm.acesso.instituicao },
              })
            : _vm._e(),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  _vm.show = true
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-plus")])],
            1
          ),
        ],
        1
      ),
      _c("emcTableItems", {
        attrs: {
          headers: _vm.headers,
          collections: _vm.collections,
          meta: _vm.meta,
          itemDelete: _vm.itemDelete,
          itemEdit: _vm.model,
          find: false,
        },
        on: {
          "update:collections": function ($event) {
            _vm.collections = $event
          },
          "update:meta": function ($event) {
            _vm.meta = $event
          },
          "update:itemDelete": function ($event) {
            _vm.itemDelete = $event
          },
          "update:item-delete": function ($event) {
            _vm.itemDelete = $event
          },
          "update:itemEdit": function ($event) {
            _vm.model = $event
          },
          "update:item-edit": function ($event) {
            _vm.model = $event
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.last_test`,
              fn: function ({ item }) {
                return [
                  item.last_tested_at
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-center justify-center flex-nowrap",
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", "max-width": "360" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-chip",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  dark: "",
                                                  color: item.last_test_success
                                                    ? "success"
                                                    : "error",
                                                },
                                              },
                                              "v-chip",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.last_test_success
                                                      ? "mdi-check-circle"
                                                      : "mdi-close-circle"
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.last_test_success
                                                    ? "OK"
                                                    : "Falha"
                                                ) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { "white-space": "pre-line" } },
                                [_vm._v(_vm._s(item.last_test_message))]
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "ml-2 text-caption grey--text text-no-wrap",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm._f("dateTime")(item.last_tested_at))
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c("span", { staticClass: "text-caption grey--text" }, [
                        _vm._v("Conexão nunca testada"),
                      ]),
                ]
              },
            },
            {
              key: "actions",
              fn: function ({ item }) {
                return [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "span",
                                  _vm._g(_vm._b({}, "span", attrs, false), on),
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "mr-2 text-none",
                                        attrs: {
                                          small: "",
                                          outlined: "",
                                          color: "primary",
                                          loading: _vm.testingId === item.id,
                                          disabled:
                                            !_vm.isTestable(item) ||
                                            _vm.testingId !== null,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            $event.stopPropagation()
                                            return _vm.testConnection(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", left: "" } },
                                          [_vm._v("mdi-connection")]
                                        ),
                                        _vm._v(" Testar conexão "),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.isTestable(item)
                              ? "Testar conexão"
                              : "Teste indisponível para este tipo"
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c("SysRegisterIntegrationParameter", {
        attrs: { model: _vm.model, show: _vm.show },
        on: {
          onCompleted: function ($event) {
            return _vm.getData()
          },
          "update:show": function ($event) {
            _vm.show = $event
          },
        },
      }),
      _c("emc-alert-snackbar", {
        attrs: {
          show: !!_vm.message.length,
          message: _vm.message,
          color: _vm.error ? "error" : "success",
        },
      }),
      _c("emc-alert-modal", {
        attrs: {
          text: _vm.textDelete,
          disabled: _vm.deleting,
          show: _vm.showDelete,
        },
        on: {
          "update:show": function ($event) {
            _vm.showDelete = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "error",
                      loading: _vm.deleting,
                      disabled: _vm.deleting,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.deleteItem()
                      },
                    },
                  },
                  [
                    _vm._v("Excluir "),
                    _c("v-icon", { attrs: { right: "", dark: "" } }, [
                      _vm._v("mdi-delete"),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }